const vn = {
  confirmModal: {
    content: 'Hành động này không thể hoàn tác',
    cancel: 'Huỷ bỏ',
    confirm: 'Xác nhận',
  },

  navTitle: {
    event: {
      root: 'Quản lý sự kiện',
      list: 'Danh sách ',
    },
  },
  filter: 'Lọc',
  clear: 'Hủy',

  simple: 'Chọn một đáp án',
  multiple: 'Chọn nhiều đáp án',
  expired: 'Hết hạn đăng nhập',
  Request_list_header: 'Danh sách yêu cầu',
  Request_searchText: 'Tìm kiếm',
  Request_startDate: 'Ngày bắt đầu',
  Request_endDate: 'Ngày kết thúc',
  Request_detail: 'Chi tiết yêu cầu',
  CreatRequest: 'Tạo yêu cầu',
  noPermission: 'Bạn không có quyền thao tác',
  requestDownload: {
    agree: 'Chấp nhận tải',
    refuse: 'Từ chối tải',
    export: 'Tải file',
    success: 'Yêu cầu download file thành công',
    fail: 'Yêu cầu download file thất bại',
  },
  auth: {
    logout: {
      name: 'Đăng xuất',
      success: 'Đăng xuất thành công',
      failed: 'Đăng xuất thất bại',
    },
  },
  popupManage: {
    list: {
      title: 'Danh sách popup',
      createButton: 'Tạo mới popup',
    },
    create: {
      success: 'Tạo mới popup thành công',
      fail: 'Tạo mới popup thất bại',
    },
    root: 'Quản lý popup',
    edit: {
      title: 'Chỉnh sửa popup',
      success: 'Chỉnh sửa popup thành công',
      fail: 'Chỉnh sửa popup thất bại',
    },
  },
  feedbackManage: {
    list: {
      title: 'Danh sách góp ý',
    },
    export: 'Xuất dữ liệu',
    root: 'Quản lý góp ý',
  },
  chartManage: {
    order: 'Đơn đặt hàng',
    title: {
      order: 'Thống kê theo đơn hàng',
      game: 'Thống kê theo trò chơi',
    },
    game: 'Trò chơi',
    export: 'Xuất dữ liệu',
    root: 'Thống kê',
  },
  tierRankManage: {
    list: {
      title: 'Danh sách thứ hạng',
      createButton: 'Tạo mới thứ hạng',
    },
    create: {
      success: 'Tạo mới thứ hạng thành công',
      fail: 'Tạo mới thứ hạng thất bại',
    },
    root: 'Quản lý thứ hạng',
    edit: {
      title: 'Chỉnh sửa thứ hạng',
      success: 'Chỉnh sửa thứ hạng thành công',
      fail: 'Chỉnh sửa thứ hạng thất bại',
    },
  },
  gameManage: {
    list: {
      title: 'Danh sách trò chơi',
      createButton: 'Tạo mới trò chơi',
    },
    create: {
      success: 'Tạo mới trò chơi thành công',
      fail: 'Tạo mới trò chơi thất bại',
    },
    root: 'Quản lý trò chơi',
    edit: {
      title: 'Chỉnh sửa trò chơi',
      success: 'Chỉnh sửa trò chơi thành công',
      fail: 'Chỉnh sửa trò chơi thất bại',
    },
    win_history: {
      title: 'Danh sách user trúng giải',
      labelGameGiftId: 'Mã giải',
      labelSearchText: 'Số điện thoại',
      labelStartDate: 'Ngày bắt đầu',
      labelEndDate: 'Ngày kết thúc',
      search: 'Tìm kiếm',
      clear: 'Xóa hết',
    },
  },
  notificationManage: {
    list: {
      title: 'Danh sách thông báo',
      createButton: 'Tạo mới thông báo',
    },
    create: {
      success: 'Tạo mới thông báo thành công',
      fail: 'Tạo mới thông báo thất bại',
    },
    root: 'Quản lý thông báo',
    edit: {
      title: 'Chỉnh sửa thông báo',
      success: 'Chỉnh sửa thông báo thành công',
      fail: 'Chỉnh sửa thông báo thất bại',
    },
    delete: {
      success: 'Xóa thông báo thành công !',
      error: 'Xóa thông báo thất bại !',
    },
  },
  event: {
    list: {
      delete: {
        single: {
          success: 'Xoá sự kiện thành công',
          failed: 'Xoá sự kiện thất bại',
          confirm: 'Bạn có chắc chắn muốn xoá sự kiện {{eventName}} không ?',
        },
        multiple: {
          success: 'Xoá {{length}} sự kiện thành công',
          failed: 'Xoá {{length}} sự kiện thất bại',
          confirm: 'Bạn có chắc muốn xoá {{length}} sự kiện không ?',
        },
      },
      filter: {
        searchTitle: 'Tìm kiếm sự kiện',
        startDate: 'Ngày bắt đầu',
        endDate: 'Ngày kết thúc',
        submit: 'Lọc',
        reset: 'Hủy',
      },
      table: {
        header: {
          name: 'Tên',
          product: 'Sản phẩm áp dụng',
          startDate: 'Ngày bắt đầu',
          endDate: 'Ngày kết thúc',
          createdDate: 'Ngày tạo',
          status: 'Trạng thái',
        },
      },
    },
    edit: 'Chỉnh sửa sự kiện',
    create: 'Tạo mới sự kiện',
    title: 'Quản lý sự kiện',
    listEvent: 'Danh sách sự kiện',
    form: {
      name: 'Tên sự kiện',
      product: 'Sản phẩm áp dụng',
      startDate: 'Ngày bắt đầu',
      endDate: 'Ngày kết thúc',
      status: 'Trạng thái',
      eventReward: {
        title: 'Phần thưởng sự kiện',
        type: 'Loại',
        value: 'Giá trị',
      },
      type: 'Loại sự kiện',
    },
  },

  common: {
    table: {
      pagination: {
        rowsPerPage: 'Số dòng mỗi trang:',
      },
      dense: 'Thu gọn',
    },
    tooltip: {
      delete: {
        title: 'Xoá',
      },
      edit: {
        title: 'Sửa',
      },
      detail: {
        title: 'Chi tiết',
      },
    },
  },
  yupPostProductAttribute: {
    type: 'Trường này là bắt buộc',
    lang: 'Trường này là bắt buộc',
    name: 'Trường này là bắt buộc',
    slug: 'Trường này là bắt buộc',
    description: 'Trường này là bắt buộc',
  },
  rejectDownload: {
    success: 'Từ chối download file thành công',
    fail: 'Từ chối download file thất bại',
  },
  approveDownload: {
    success: 'Duyệt tải file thành công',
    fail: 'Duyệt tải file thất bại',
  },

  configFeature: 'Quản lý tính năng',
  ListConfigFeature: 'Danh sách tính năng',
  EditConfigFeature: {
    edit: {
      success: 'Chỉnh sửa tính năng thành công',
      fail: 'Chỉnh sửa tính năng thất bại',
    },
  },
  configEvent: {
    title: 'Tính năng sự kiện',
    list: 'Tính năng sự kiện',
    edit: {
      success: 'Chỉnh sửa tính năng sự kiện thành công',
      fail: 'Chỉnh sửa tính năng sự kiện thất bại',
    },
    tableHeader: {
      code: 'Mã tính năng',
      desc: 'Miêu tả',
      status: 'Trạng thái',
      startDate: 'Ngày bắt đầu',
      endDate: 'Ngày kết thúc',
      edit: 'Chỉnh sửa',
    },
    button: {
      cancel: 'Hủy bỏ',
      edit: 'Chỉnh sửa',
    },
    modal: {
      title: 'Thay đổi thông tin tính năng sự kiện',
      desc: 'Miêu tả tính năng',
      status: 'Trạng thái',
      startDate: 'Ngày bắt đầu',
      endDate: 'Ngày kết thúc',
    },
  },

  successUpdatePass: 'Cập nhật mật khẩu thành công',
  failUpdatePass: 'Cập nhật mật khẩu thất bại',
  notYet: 'chưa có',
  notApprove: 'Chưa có ngày duyệt',
  app: `ứng dụng`,
  user: `người dùng`,
  shop: `cửa hàng`,
  blog: `blog`,
  post: `bài viết`,
  mail: `thư`,
  chat: `trò chuyện`,
  cards: `thẻ`,
  posts: `danh sách bài viết`,
  kanban: `bảng`,
  general: `chung`,
  banking: `ngân hàng`,
  booking: `đặt phòng`,
  profile: `Hồ sơ`,
  account: `Tài khoản`,
  product: `sản phẩm`,
  invoice: `hóa đơn`,
  details: `chi tiết`,
  checkout: `thanh toán`,
  calendar: `lịch`,
  analytics: `phân tích`,
  ecommerce: `thương mại điện tử`,
  management: `quản lý`,
  menu_level_1: `menu cấp 1`,
  menu_level_2a: `menu cấp 2a`,
  menu_level_2b: `menu cấp 2b`,
  menu_level_3a: `menu cấp 3a`,
  menu_level_3b: `menu cấp 3b`,
  menu_level_4a: `menu cấp 4a`,
  menu_level_4b: `menu cấp 4b`,
  item_disabled: `mục vô hiệu`,
  item_label: `mục nhãn`,
  item_caption: `mục chú thích`,
  item_external_link: `mục liên kết ngoài`,
  description: `mô tả`,
  other_cases: `trường hợp khác`,
  item_by_roles: `mục theo vai trò`,
  search: `tìm kiếm`,
  reset: `cài lại`,
  export: `xuất excel`,
  Detail: `Detail`,
  history_winning: `lịch sử trúng giải`,
  only_admin_can_see_this_item: `Chỉ có quản trị viên mới có thể nhìn thấy mục này`,
  update_success: `Cập nhật thành công`,
  old_password: `Mật khẩu cũ`,
  new_password: `Mật khẩu mới`,
  confirm_password: `Xác nhận mật khẩu`,
  Save: `Lưu`,
  old_password_required: `Mật khẩu cũ không được trống`,
  password_min_6: `Mật khẩu phải có độ dài từ 6 kí tự trở lên`,
  new_password_require: `Mật khẩu mới không được để trống`,
  password_must_match: `Mật khẩu mới và mật khẩu xác nhận phải giống nhau`,
  change_password: `Đổi mật khẩu`,
  account_settings: `Cài đặt tài khoản`,
  allowed: `Chấp nhận`,
  max_size_of: `kích thước tối đa`,
  registration_date: `Ngày đăng kí`,
  first_name: `Họ`,
  last_name: `Tên`,
  phone_number: `Số điện thoại`,
  status: `Trạng thái`,
  rank: `Hạng`,
  address: `Địa chỉ`,
  fname_require: `Họ không được để trống`,
  lname_require: `Tên không được để trống`,
  pnumber_not_valid: `Số điện thoại không hợp lệ`,
  address_require: `Địa chỉ không được để trống`,
  startDate: 'Ngày bắt đầu',
  endDate: 'Ngày Kết Thúc',
  wheelNamePlaceholder: 'Nhập tên vòng quay của bạn...',
  wheelName: 'Tên Vòng Quay',
  giftCode: 'Mã Quà',
  quantity: 'Số Lượng',
  winningRate: 'Tỉ Lệ Thắng',
  cancel: 'Hủy',
  submit: 'Lưu',
  addNewRow: 'Thêm Giải Mới',
  dashboard: 'Bảng Điều Khiển',
  configWheel: 'Cấu hình vòng quay',
  create: 'Tạo Mới',
  titleConfigWheel: 'Tạo Mới Vòng Quay',
  list: 'Danh Sách',
  logout_success: `Đăng xuất thành công`,
  home: `Trang chủ`,
  settings: `Cài đặt`,
  logout: `Đăng xuất`,
  name: `Họ tên`,
  update_fail: `Cập nhật thất bại. Xin vui lòng thử lại`,
  giftList: 'Danh sách quà tặng',
  gift: 'Quà tặng',
  confirmDeleteMulGift: 'Bạn có chắc muốn xoá {{length}} quà tặng không ?',
  confirmDeleteSigGift: 'Bạn có chắc chắn muốn xoá quà tặng {{giftName}} không ?',
  deleteGiftSuccess: 'Xóa quà tặng thành công',
  deleteGiftFailed: 'Xóa quà tặng thất bại',
  createGift: 'Thêm quà tặng',
  createGiftSuccess: 'Tạo quà tặng thành công',
  createGiftFailed: 'Tạo quà tặng thất bại',
  giftName: 'Tên quà tặng',
  name_required: 'Tên không được để trống',
  price_required: 'Giá tiền không được để trống',
  price_more_than_0: 'Giá tiền phải lớn hơn 0',
  thumbnail_required: 'Ảnh thumbnail không được để trốngs',
  createNewWheelSuccess: 'Tạo vòng quay mới thành công',
  createNewWheelFailed: 'Tạo vòng quay mới thất bại',
  errorMessageRequiredForWheelName: 'Vui lòng điền tên vòng quay',
  errorMsgForEndDateRequired: 'Vui lòng điền ngày kết thúc vòng quay',
  errorMsgForStartDate: 'Vui lòng điền ngày bắt đầu vòng quay',
  startWheel: 'Bắt đầu quay',
  resetWheel: 'Reset',
  uploadBgImageWheel: 'Tải ảnh vòng quay',
  previewWheel: 'Xem trước vòng quay',
  titleCodeRelease: 'Danh sách mã code phát hành',
  eventName: 'Tên sự kiện',
  amount: 'Số lượng',
  expiresAt: 'Hết hạn vào ngày',
  ok: 'OK',
  newCode: 'Mã code mới',
  useTime: 'Số lần sử dụng',
  titleCodeCreate: 'Tạo mới mã code',
  successEdit: 'Chỉnh sửa mã code thành công',
  errorEdit: 'Chỉnh sửa mã code thất bại',
  saveChange: 'Lưu thay đổi',
  confirmChange: 'Bạn có muốn lưu lại các thay đổi không?',
  yupEventName: 'Vui lòng không để trống tên sự kiện',
  codeUseTimePlacehoder: 'Vui lòng nhập số lần sử dụng codes',
  codeAmountPlacehoder: 'Vui lòng nhập tổng số code phát hành',
  titleEditEvent: 'Chỉnh sửa Sự kiện',
  view: 'Xem',
  edit: 'Chỉnh sửa',
  remove: 'Xóa',
  eventList: 'Danh sách sự kiện',
  imageIsNotUploaded: 'Vui lòng tải ảnh nền vòng quay!',
  editWheelSuccess: 'Chỉnh sửa vòng quay thành công!',
  editWheelError: 'Chỉnh sửa vòng quay thất bại',
  isNotValidDate: 'Ngày không hợp lệ',
  getQRCode: 'Lấy mã QR',
  downloadQRCode: 'Tải mã QR',
  expireAt: 'Ngày hết hạn',
  infoSendSuccessfully: 'Thông tin của bạn đã được gửi thành công !',
  pleaseWaitForAdminApproveAccount:
    'Vui lòng chờ để đội ngũ admin của chúng tôi duyệt thông tin của bạn',
  emailConfirmation: 'Vui lòng xác nhận email của bạn',
  sendEmailTo: 'Chúng tôi đã gửi tin nhắc xác nhận tới',
  confirmValidEmail:
    'Để xác thực tài khoản email của bạn. Sau khi nhận được, vui lòng theo link gắn liền để hoàn thành quy trình đăng kí tài khoản của bạn',
  deleteProductAttribute: 'Xóa',
  editProductAttribute: 'Chỉnh sửa',
  manage_product_attribute: 'Quản lý thuộc tính sản phẩm',
  list_product_attribute: 'Danh sách thuộc tính sản phẩm',
  create_product_attribute: 'Tạo mới thuộc tính sản phẩm',
  Lang: 'Ngôn ngữ',
  Type: 'Loại',
  Name: 'Tên',
  Slug: 'Đoạn văn ngắn',
  Description: 'Chi tiết đoạn văn',
  delete: 'Xóa',
  productMerchant: {
    new: {
      contentOnly1: 'Với loại sản phẩm bạn đang chọn là: ',
      contentOnly2: ' thì chỉ được chọn duy nhất 1 biến thể',
      contentOnly3:
        'Nếu bạn cần chọn nhiều biến thể hơn vui lòng chọn lại loại sản phẩm: Nhiều biến thể',
      labelDefault:
        '* Vui lòng chọn biến thể mặc định, nếu không chọn thì biến thể đầu tiên sẽ được đặt là biến thể mặc định',
      labelCancel: 'Vẫn thoát',
      labelReturn: 'Quay lại',
      contentReset: 'Nếu thoát ngay lúc này bạn sẽ mất hết các lựa chọn',
      contentReset2: "hãy nhấn 'Thêm' nếu bạn muốn lưu lại các lựa chọn của mình",
      labelNotice: 'Lưu ý!',
      default: 'Mặc định',
      salePoint: 'Điểm sale',
      point: 'Điểm',
      attribute: 'Thuộc tính',
      attributeTerm: 'Giá trị thuộc tính',
      labelSku: 'Sku',
      labelSimple: 'Một biến thể',
      labelConfig: 'Nhiều biến thể',
      labelVirtual: 'Voucher',
      price: 'Giá',
      sale: 'Sale',
      quantity: 'Số lượng',
      sku: 'Sku',
      addVariant: 'Thêm mới biến thể',
      salePrice: 'Giá sale',
      add: 'Thêm',
      labelName: 'Tên sản phẩm',
      slug: 'Slug',
      labelShortDescription: 'Mô tả tổng quan sản phẩm',
      description: 'Mô tả chi tiết sản phẩm',
      descriptionPlacehoder: 'Viết về sản phẩm của bạn...',
      images: 'Ảnh sản phẩm',
      createProduct: 'Tạo mới sản phẩm',
      cancel: 'Thoát',
      productType: 'Loại sản phẩm',
      labelStatus: 'Trạng thái',
      labelLang: 'Ngôn ngữ',
      labelCategory: 'Danh mục',
      labelTag: 'Gắn thẻ',
      labelOnSale: 'Đang khuyến mãi',
      labelFeatured: 'Sản phẩm nổi bật',
      labelTaxStatus: 'Giá đã gồm thuế',
      addSuccess: 'Thêm sản phẩm thành công',
      addFail: 'Thêm sản phẩm thất bại',
      thumbnail: 'Thêm ảnh thất bại',
      title: 'Thêm mới sản phẩm',
      new: 'Sản phẩm mới',
      imageLabel: 'Kéo thả hoặc chọn hình ảnh cho sản phẩm của bạn ở đây,',
      desImageLabel: 'Kéo files vào hoặc click vào',
      here: 'đây',
      fromMachine: 'từ máy tính của bạn',
      allow: 'Cho phép',
      maxSize: 'Dung lượng lớn nhất',
      schemaName: 'Vui lòng không để trống tên sản phẩm',
      schemaSlug: 'Vui lòng không để trống slug sản phẩm',
      schemaShortDescription: 'Vui lòng thêm mô tả ngắn cho sản phẩm của bạn',
      schemaDescription: 'Vui lòng thêm mô tả chi tiết cho sản phẩm của bạn',
      schemaCategoryMin: 'Vui lòng thêm ít nhất 1 danh mục cho sản phẩm',
      schemaCategory: 'Vui lòng không để trống danh mục',
      schemaTagMin: 'Vui lòng thêm ít nhất 1 dán nhãn cho sản phẩm',
      schemaTag: 'Vui lòng không để trống gắn thẻ',
      schemaImage: 'Vui lòng không để trống ảnh sản phẩm',
      newTitleNavbar: 'Tạo mới sản phẩm',
    },
  },
  ListProduct: {
    delete: 'Xóa',
    edit: 'Sửa',
    title: 'Danh sách sản phẩm',
    list: 'Danh sách sản phẩm',
    newProduct: 'Thêm sản phẩm mới',
    searchPlacehoder: 'Nhập kí tự cần tìm kiếm',
    labelSearch: 'Tìm kiếm',
    labelStatus: 'Trạng thái',
    labelType: 'Loại tìm kiếm',
    labelTaxStatus: 'Thuế',
    labelProductType: 'Loại sản phẩm',
    clear: 'Hủy',
    search: 'Tìm kiếm',
    deleteSuccess: 'Xóa sản phẩm thành công',
    deleteFail: 'Xóa sản phẩm thất bại',
    deletePopup: 'Xóa sản phẩm',
    confirmDelete: 'Bạn có chắc chắn muốn xóa sản phẩm này?',
    cancel: 'thoát',
    dense: 'Hiển thị dày hơn',
    titleProductNavbar: 'Sản phẩm',
    listTitleNavbar: 'Danh sách sản phẩm',
  },
  variant: {
    new: {
      numberAtt: '*Thuộc tính ',
      labelAddAtt: 'Thêm thuộc tính',
      titleAtt: ' Thêm thuộc tính cho biến thể',
      successBar: 'Thêm biến thể thành công',
      failBar: 'Thêm biến thể thất bại',
      labelName: 'Tên biến thể',
      labelSku: 'Sku',
      labelQuantity: 'Số lượng',
      labelAttribute: 'Thuộc tính sản phẩm',
      labelTerm: 'Giá trị của thuộc tính',
      labelPrice: 'Giá tiền',
      labelSale: 'Giá sale',
      labelPoint: 'Điểm',
      labelSalePoint: 'Điểm sale',
      labelImg: 'Cho phép',
      labelExternal: 'E-Voucher',
      labelExNote:
        '* Nếu là E-Voucher, vui lòng nhập dòng này. Nếu không phải, vui lòng bỏ trống',
      labelWidth: 'Chiều rộng (cm)',
      labelHeight: 'Chiều cao (cm)',
      labelLength: 'Chiều dài (cm)',
      labelWeight: 'Cân nặng (g)',
    },
    edit: {
      showSuccess: 'Chỉnh sửa biến thể thành công',
      showError: 'Chỉnh sửa biến thể thất bại',
      typeEx: 'Loại biến thể',
    },
  },
  DetailProduct: {
    title: 'Chi tiết sản phẩm',
    detail: 'Chi tiết',
    shortDes: 'Mô tả tổng quan',
    slug: 'Slug',
    lang: 'Ngôn ngữ',
    category: 'Danh mục',
    tag: 'Gắn thẻ',
    variant: 'Biến thể',
    isFeatured: 'Sản phẩm nổi bật',
    onSale: 'Khuyến mãi',
    trueSale: 'Đang khuyến mãi',
    failSale: 'Chưa có khuyến mãi',
    des: 'Mô tả chi tiết sản phẩm',
  },
  EditProduct: {
    labelPrice: 'Giá',
    labelSalePrice: 'Giá sale',
    labelQuantity: 'Số lượng',
    labelSku: 'Sku',
    editSuccess: 'Sửa sản phẩm thành công',
    editFail: 'Sửa sản phẩm thất bại',
    labelName: 'Tên sản phẩm',
    labelSlug: 'Slug',
    labelShortDes: 'Mô tả tổng quan',
    labelCategory: 'Danh mục',
    labelTag: 'Gắn thẻ',
    labelTax: 'Tình trạng thuế',
    labelStatus: 'Trạng thái sản phẩm',
    labelLang: 'Ngôn ngữ',
    labelType: 'Kiểu sản phẩm',
    labelFeatured: 'Sản phẩm nổi bật',
    labelOnSale: 'Đang sale',
    variantInfo: 'Thông tin biến thể sản phẩm',
    basicInfo: 'Thông tin cơ bản sản phẩm',
  },
  attribute: {
    new: {
      titleNew: 'Thêm mới thuộc tính',
      titleList: 'Danh sách thuộc tính',
      titleAttribute: 'Thuộc tính sản phẩm',
      btnCreate: 'Thêm mới thuộc tính',
      Name: 'Tên thuộc tính',
      labelDescription: 'Mô tả',
      pageTitle: 'Tao-moi-thuoc-tinh',
      addSuccess: 'Tạo mới thuộc tính thành công',
      addFail: 'Tạo mới thuộc tính thất bại',
      labelType: 'Kiểu thuộc tính',
      labelSlug: 'Slug',
      labelLang: 'Ngôn ngữ',
      labelName: 'Loại thuộc tính',
      labelBtnCreate: 'Tạo mới',
      labelBtnCancel: 'Thoát',
      schemaName: 'Vui lòng không để trống tên thuộc tính',
      schemaSlug: 'Vui lòng không để trống slug',
      schemaDescription: 'Vui lòng thêm mô tả cho thuộc tính',
      schemaType: 'Vui lòng chọn kiểu cho thuộc tính',
      schemaLang: 'Vui lòng chọn ngôn ngữ cho thuộc tính',
    },
    edit: {
      editSuccess: 'Sửa đổi thuộc tính thành công',
      editFail: 'Sửa đổi thuộc tính thất bại',
      labelType: 'Kiểu thuộc tính',
      labelSlug: 'Slug',
      labelLang: 'Ngôn ngữ',
      labelName: 'Tên thuộc tính',
      labelDescription: 'Mô tả',
      labelBtnSave: 'Lưu thay đổi',
      labelBtnCancel: 'Thoát',
      titleEdit: 'Chỉnh sửa thuộc tính',
      edit: 'Chỉnh sửa',
      schemaName: 'Vui lòng không để trống tên thuộc tính',
      schemaSlug: 'Vui lòng không để trống slug',
      schemaDescription: 'Vui lòng thêm mô tả cho thuộc tính',
    },
    list: {
      pageTitle: 'Danh-sach-thuoc-tinh',
      titleNew: 'Thêm mới thuộc tính',
      titleList: 'Danh sách thuộc tính',
      titleAttribute: 'Thuộc tính sản phẩm',
      btnCreate: 'Thêm mới thuộc tính',
      Name: 'Tên thuộc tính',
      labelDescription: 'Mô tả',
      yes: 'Có',
      no: 'Không',
      deleteSuccess: 'Xóa giá trị thuộc tính thành công',
      deleteFail: 'Xóa giá trị thuộc tính thất bại',
      deleteTitle: 'Xóa giá trị thuộc tính',
      deleteContent: 'Bạn có chắc chắn muốn xóa những giá trị thuộc tính này',
    },
  },
  term: {
    navTitle: 'Giá trị thuộc tính',
    list: {
      navListTitle: 'Danh sách giá trị thuộc tính',
      pageTitle: 'Danh-sach-gia-tri-thuoc-tinh',
      title: 'Danh sách giá trị thuộc tính',
      list: 'Danh sách',
      deleteSuccess: 'Xóa giá trị thuộc tính thành công',
      deleteFail: 'Xóa giá trị thuộc tính thất bại',
      deleteTitle: 'Xóa giá trị thuộc tính',
      deleteContent: 'Bạn có chắc muốn xóa những giá trị thuộc tính này?',
    },
    new: {
      navNewTitle: 'Thêm mới giá trị thuộc tính',
      labelAttribute: 'Thuộc tính sản phẩm',
      labelLang: 'Ngôn ngữ',
      labelTerm: 'Giá trị',
      labelBtnRemove: 'Loại giá trị thuộc tính ở ngôn ngữ khác',
      labelBtnAdd: 'Thêm giá trị thuộc tính ở ngôn ngữ khác',
      title: 'Thêm mới giá trị thuộc tính',
      termTitle: 'Giá trị thuộc tính',
      newTitle: 'Thêm mới',
      newSuccess: 'Thêm mới giá trị thuộc tính thành công',
      newFail: 'Thêm mới giá trị thuộc tính thất bại',
      addBtn: 'Thêm mới',
    },
    edit: {
      labelAttribute: 'Thuộc tính sản phẩm',
      labelLang: 'Ngôn ngữ',
      labelTerm: 'Giá trị',
      labelBtnRemove: 'Loại giá trị thuộc tính ở ngôn ngữ khác',
      labelBtnAdd: 'Thêm giá trị thuộc tính ở ngôn ngữ khác',
      title: 'Chỉnh sửa giá trị thuộc tính',
      termTitle: 'Giá trị thuộc tính',
      editTitle: 'Chỉnh sửa',
      editSuccess: 'Chỉnh sửa giá trị thuộc tính thành công',
      editFail: 'Chỉnh sửa giá trị thuộc tính thất bại',
    },
  },
  ListOrder: {
    titleOrderNavbar: 'Quản lý đơn quà',
    listTitleNavbar: 'Quản lý đơn quà vật lý',
    listVoucher: 'Quản lý đơn quà E-Voucher',
  },
  ConfigPoint: {
    New: {
      successBar: 'Thêm mới thành công',
      failBar: 'Thêm mới thất bại',
      labelType: 'Kiểu',
      title: 'Thêm mới cấu hình tích điểm',
      titleNav: 'Cấu hình tích điểm',
      titleNew: 'Thêm mới',
      labelPoint: 'Điểm tương ứng',
      labelCode: 'Mã tương ứng',
      labelDes: 'Mô tả',
      labelIsActive: 'Trạng thái hoạt động',
      labelWeight: 'Trọng lượng',
      labelProductGroup: 'Nhóm sản phẩm',
    },
    List: {
      title: 'Danh sách tích điểm',
      tableCode: 'Tên Mã',
      tablePoint: 'Điểm',
      tableProductGroup: 'Nhóm sản phẩm',
      tableType: 'Kiểu',
      tableWeight: 'Trọng lượng',
      tableIsActive: 'Đang hoạt động',
      labelCodeFilter: 'Tên mã',
      labelNone: 'Không có',
    },
    Edit: {
      title: 'Chỉnh sửa cấu hình tích điểm',
      edit: 'Chỉnh sửa',
    },
  },
  giftIsNotAvailable: 'Không có quà tặng',
  homeConfig: 'Cấu hình trang chủ',
  previewHomePageTitle: 'Preview home page',
  survey: {
    root: 'Quản lý Khảo sát',
    list: 'Danh sách khảo sát',
    addQuestion: 'Thêm 1 câu hỏi',
    addAnswere: 'Thêm 1 trả lời',
    listQuestion: 'Danh sách câu hỏi',
    inforQuestion: 'Thông tin câu hỏi',
    back: 'Trở lại',
    create: {
      title: 'Thêm khảo sát',
      noticeTwoAnswere: 'Có ít nhất hai câu trả lời',
      sucess: 'Tạo cuộc khảo sát thành công',
      fail: 'Tạo cuộc khảo sát thất bại',
    },
    action: {
      delete: {
        root: 'Bạn có chắc chắn muốn xóa không?',
        success: 'Xóa thành công',
        fail: 'Xóa thất bại',
      },
      view_user: {
        root: 'Người tham gia',
      },
      export: {
        sucess: 'Yêu cầu xuất file thành công !',
        fail: 'Yêu cầu xuất file thất bại  !',
        redirectExportList:
          'Bạn có muốn tới trang danh sách xuất file để tiến hành tải file ?',
        redirectImportList:
          'Bạn có muốn tới trang danh sách nhập file để xem tiến độ nhập file ?',
      },
    },
    view: 'Thông tin khảo sát',
    edit: {
      title: 'Chỉnh sửa khảo sát',
      sucess: 'Edit cuộc khảo sát thành công',
      fail: 'Edit cuộc khảo sát thất bại',
    },
    userSurvey: {
      title: 'Thông tin',
      header: 'Thông tin câu trả lời',
      list: 'Danh sách người trả lời khảo sát',
      name: 'Họ và tên',
      phoneNumber: 'Số điện thoại',
      answersDetail: 'Chi tiết câu trả lời',
      time: 'Thời gian tham gia khảo sát',
      export: 'Xuất dữ liệu',
    },
  },
  requestManagement: {
    root: 'Quản lý Request',
    list: 'Danh sách yêu cầu',
    createSpoon: 'Tạo mã muỗng',
    createSBPS: 'Tạo mã sữa bột pha sẵn',
    notiCreateSuccess: 'Tạo mới thành công !',
    notiCreateError: 'Tạo mới thất bại !',
    createField: {
      productGroup: 'Nhóm sản phẩm',
      quantity: 'Số lượng',
      weight: 'Khối lượng',
      useDate: 'Tháng sản xuất',
      status: 'Trạng thái',
      code: 'Mã code',
      placeholderQuantity: 'Số lượng điền từ 1 - 15.000',
      spoonType: 'Loại muỗng',
    },
    historyDownload: {
      title: 'Lịch sử tải file',
      list: 'Danh sách lịch sử tải file',
      searchFile: 'Tìm kiếm tên file',
    },
    button: {
      cancel: 'Hủy bỏ',
      create: 'Thêm mới',
    },
    listQR: 'Danh sách QR Code',
    acceptFile: 'Duyệt file',
    denyFile: 'Từ chối duyệt file',
  },

  // administrators
  administrators: {
    navTitle: 'Quản lý quản trị viên',
    list: {
      title: 'Danh sách quản trị viên',
    },
    listQR: 'Danh sách QR Code',
  },
  featureConfig: {
    title: 'Quản lý tính năng',
    list: 'Danh sách tính năng',
    editSuccess: 'Chỉnh sửa tính năng thành công !',
    editError: 'Chỉnh sửa tính năng thất bại !',
    tableHeader: {
      code: 'Mã tính năng',
      name: 'Tên tính năng',
      status: 'Trạng thái',
      edit: 'Chỉnh sửa',
    },
    button: {
      cancel: 'Hủy bỏ',
      edit: 'Chỉnh sửa',
    },
    modal: {
      title: 'Thay đổi thông tin tính năng',
      description: 'Nhập thông tin cần thay đổi.',
      name: 'Tên tính năng',
      status: 'Trạng thái',
    },
  },
  group_policy: {
    root: 'Nhóm phân quyền',
    label: {
      name: 'Tên nhóm quyền',
      description: 'Mô tả',
      status: 'Trạng thái',
      type: 'Loại',
    },
    list: {
      root: 'Danh sách nhóm quyền',
      add: 'Thêm nhóm quyền',
      delete: {
        content: 'Bạn chắc chắn muốn xóa {{groupName}} không?',
        multiple_content: 'Bạn chắc chắn muốn xóa {{length}} nhóm không?',
        root: 'Xóa',
        success: 'Xóa nhóm thành công',
        fail: 'Xóa nhóm thất bại',
        multiple_success: 'Xóa thành công {{length}} nhóm',
        multiple_fail: 'Xóa thất bại {{length}} nhóm',
      },
    },

    schema: {
      required: 'Trường này không được để trống',
      min: 'Phải có ít nhất 1 quyền',
    },
    create: {
      root: 'Tạo nhóm phân quyền',
      name: 'Tiêu đề',
      description: 'Mô tả',
      policies: 'Nhóm quyền',
      success: 'Tạo nhóm quyền thành công',
      fail: 'Tạo nhóm quyền thất bại',
    },
    edit: {
      root: 'Chỉnh sửa nhóm phân quyền',
      success: 'Sửa nhóm phân quyền thành công',
      fail: 'Sửa nhóm phân quyền thất bại',
      status: 'Trạng thái',
    },
  },
  // manageAgent
  manageAgent: {
    navTitle: 'Quản lý Admin',
    list: {
      title: 'Danh sách Admin',
      labelSearch: 'Nhập từ khóa',
      labelStatus: 'Trạng thái',
      labelRank: 'Xếp hạng',
      successBar: 'Xóa admin thành công',
      failBar: 'Xóa admin thất bại! Xin vui lòng thử lại',
      modalTitle: 'Xóa Admin',
      modalContent: 'Bạn có chắc chắn muốn xóa Admin này?',
    },
    new: {
      title: 'Thêm mới Admin',
      labelEmail: 'Email',
      labelPassword: 'Mật khẩu',
      labelConfirmPassword: 'Xác nhận mật khẩu',
      labelGrPolicy: 'Phân quyền',
      emailSchema: 'Vui lòng không để trống Email',
      newPasswordMinSchema: 'Mật khẩu phải có ít nhất 6 kí tự',
      newPasswordSchmema: 'Vui lòng không để trống mật khẩu',
      confirmPasswordSchema: 'Mật khẩu không khớp, vui lòng thử lại',
      confirmPasswordRequired: 'Bạn cần xác nhận lại mật khẩu',
      groupPolicyIdsSchema: 'Vui lòng không để trống phân quyền',
    },
    edit: {
      tittle: 'Chỉnh sửa Admin',
      successBar: 'Chỉnh sửa Admin thành công',
      failBar: 'Chỉnh sửa Admin thất bại',
      id: 'Id',
      rank: 'Xếp hạng',
      policy: 'Phân quyền',
      name: 'Tên Admin',
      email: 'Email',
      address: 'Địa chỉ',
      phone: 'Số điện thoại',
      status: 'Trạng thái',
    },
  },
  userManage: {
    title: 'Quản lý User',
    list: 'Danh sách User',
    rank: 'Hạng thành viên',
    detail: 'Thông tin User',
    name: 'Họ và tên',
    address: 'Địa chỉ',
    email: 'Email',
    birth: 'Ngày sinh',
    lastVisited: 'Ngày đăng nhập gần nhất',
    createdAt: 'Ngày tạo',
    gender: 'Giới tính',
    totalPoints: 'Tổng xu',
    lastScan: 'Ngày tích xu cuối cùng',
    phoneNumber: 'Số điện thoại',
    status: 'Trạng thái',
    blockAccount: 'Khóa tài khoản',
    block: 'Chặn tích xu',
    goBack: 'Trở về',
    edit: 'Chỉnh sửa',
    editTitle: 'Chỉnh sửa người dùng',
    viewHistoryAddPoint: 'Lịch sử quét mã',
    viewHistoryGiftExchange: 'Lịch sử đổi quà',
    save: 'Lưu',
    export: {
      successExport: 'Xuất file Excel thành công',
      failedExport: 'Xuất file Excel thất bại',
      titleConfirmExport:
        'Bạn có muốn tới trang danh sách xuất file để tiến hành tải file?',
      subtitleConfirmExport: 'Hành động này không thể hoàn tác',
      closeConfirmExport: 'Hủy',
      agreeConfirmExport: 'Đồng ý',
    },
  },
  tag: {
    new: {
      title: 'Thêm mới tag',
      name: 'Tên',
      slug: 'Slug',
      desc: 'Mô tả',
      successBar: 'Thêm mới tag thành công',
      errorBar: 'Thêm mới tag thất bại',
    },
    list: {
      title: 'Danh sách tag',
      create: 'Thêm mới',
      successBar: 'Xóa tag thành công',
      errorBar: 'Xóa tag thất bại',
      confirmDelete: 'Xác nhận xóa tag',
    },
    edit: {
      title: 'Chỉnh sửa Tag',
      successBar: 'Chỉnh sửa tag thành công',
      errorBar: 'Chỉnh sửa tag thất bại',
    },
  },
  storeInMap: {
    new: {
      title: 'Thêm mới cửa hàng (bản đồ)',
      successBar: 'Thêm mới cửa hàng (bản đồ) thành công',
      errorBar: 'Thêm mới cửa hàng (bản đồ) thất bại',
    },
    list: {
      title: 'Danh sách cửa hàng (bản đồ)',
      create: 'Thêm mới',
      successBar: 'Xóa cửa hàng (bản đồ) thành công',
      errorBar: 'Xóa cửa hàng (bản đồ) thất bại',
      confirmDelete: 'Xác nhận xóa cửa hàng (bản đồ)',
    },
    edit: {
      title: 'Chỉnh sửa cửa hàng (bản đồ)',
      successBar: 'Chỉnh sửa cửa hàng (bản đồ) thành công',
      errorBar: 'Chỉnh sửa cửa hàng (bản đồ) thất bại',
    },
  },
  category: {
    new: {
      title: 'Thêm mới Danh mục',
      lang: 'Ngôn ngữ',
      name: 'Tên',
      slug: 'Slug',
      desc: 'Mô tả',
      successBar: 'Thêm mới danh mục thành công',
      errorBar: 'Thêm mới danh mục thất bại',
    },
    title: 'Quản lí danh mục',
    list: 'Danh sách danh mục',
    deleteSuccess: 'Xóa danh mục thành công !',
    deleteFail: 'Xóa danh mục thất bại !',
    add: 'Thêm mới',
    edit: {
      title: 'Chỉnh sửa Danh mục',
      success: 'Chỉnh sửa danh mục thành công !',
      error: 'Chỉnh sửa danh mục thất bại !',
    },
  },
  // manage-store
  manage_store_title: 'Quản lý cửa hàng',
  manage_store: {
    listStore: 'Danh sách cửa hàng',
    createStore: 'Thêm mới cửa hàng',
    editStore: 'Chỉnh sửa thông tin cửa hàng',
    detailStore: 'Chi tiết cửa hàng	',
    code_store: 'Mã cửa hàng',
    name_store: 'Tên cửa hàng',
    address_store: 'Địa chỉ',
    phone_store: 'Số điện thoại',
    referral_code: 'Mã giới thiệu',
    status: 'Trạng thái cửa hàng',

    createExternalReferrerSuccess: 'Tạo cửa hàng thành công',
    createExternalReferrerFailed: 'Tạo cửa hàng thất bại!',
    editExternalReferrerSuccess: 'Chỉnh sửa cửa hàng thành công',
    editExternalReferrerFailed: 'Chỉnh sửa cửa hàng thất bại!',
    import: {
      title: 'Nhập',
      sucess: 'Yêu cầu nhập file cửa hàng thành công , vui lòng chờ !',
      false: 'Yêu cầu nhập file cửa hàng thất bại !',
    },
    export: {
      title: 'Xuất',
      sucess: 'Yêu cầu xuất file cửa hàng thành công , vui lòng chờ !',
      false: 'Yêu cầu xuất file cửa hàng thất bại !',
    },
    create: {
      code_required: 'Mã số cửa hàng không được để trống',
      code_max: 'Mã số cửa hàng không được quá 20 kí tự',
      name_required: 'Tên cửa hàng không được để trống',
      address_required: 'Địa chỉ cửa hàng không được để trống',
      phone_required: 'Số điện thoại không được để trống',
      phone_max: 'số điện thoại không được quá 10 kí tự',
      referral_code_required: 'Mã giới thiệu không được để trống',
      referral_code_invalidType: 'sai định dạng',
      referral_code_max: 'Mã giới thiệu không được quá 9 kí tự',
    },
  },
  // order-management
  order: {
    detail: {
      customerName: 'Tên khách hàng',
      headerPhysical: 'Quản lý đơn hàng vật lý',
      headerVoucher: 'Quản lý đơn hàng E-Voucher',
      successBarGHN: 'Đầy lên GHN thất bại',
      failBarGHN: 'Đẩy lên GHN thành công',
      commonInfo: 'Thông tin chung',
      totalWeight: 'Tổng khối lượng',
      totalHeight: 'Tổng chiều cao',
      totalLength: 'Tổng chiều dài',
      totalWidth: 'Tổng chiều rộng',
      moreInfo: 'Vui lòng cung cấp thêm các thông tin sau:',
      province: 'Tỉnh/Thành phố',
      district: 'Quận/Huyện',
      service: 'Dịch vụ ',
      ok: 'Ok',
      cancel: 'Thoát',
      showProduct: 'Xem hàng',
      titleGHN: 'Đẩy lên GHN',
      failBar: 'Tải thông tin đơn hàng thất bại',
      orderInfo: 'Thông tin Đơn quà',
      deliveryInfo: 'Thông tin giao hàng',
      productInfo: 'Thông tin sản phẩm',
      push: 'Đẩy Lên GHN',
      fix: 'Sửa',
      orderTitle: 'Chi tiết đơn quà',
      listOrder: 'Danh sách đơn quà',
      labelStatus: 'Trạng thái đơn hàng',
      totalMoney: 'Tổng tiền sản phẩm',
      totalDiscount: 'Tổng tiền giảm giá',
      totalShipfee: 'Tổng giá ship',
      moneyType: 'Loại tiền giảm giá',
      createdOrder: 'Ngày tạo đơn',
      payOrder: 'Ngày thanh toán',
      code: 'Mã giao dịch',
      note: 'Ghi chú',
      infoOrder: 'Thông tin đơn quà',
      infoShipping: 'Thông tin giao hàng',
      idUser: 'Id của người dùng',
      userName: 'Tên người nhận',
      userPhoneNumber: 'Số điện thoại',
      userAddress: 'Địa chỉ người nhận',
      infoProduct: 'Thông tin sản phẩm',
      userPhone: 'Số điện thoại người tạo đơn',
      noticeSize: '*Lưu ý: kích thước lớn hơn 150cm sẽ không thể đẩy lên GHN!',
      shopLabel: '*Cửa hàng - nơi gửi',
      addressLabel: '*Địa chỉ - nơi nhận',
      refund: 'Hoàn xu',
      refundRequest: {
        list: 'Danh sách yêu cầu hoàn xu',
        sucess: 'Yêu cầu hoàn xu thành công',
        fail: 'Yêu cầu hoàn xu thất bại',
        reject: {
          sucess: 'Từ chối hoàn xu thành công',
          fail: 'Từ chối hoàn xu thất bại',
        },
      },
      refundForm: {
        title: 'Thông tin hoàn xu',
        desc: 'Nhập thông tin hoàn xu của đơn hàng',
        quantity: 'Số xu hoàn',
        content: 'Nội dung hoàn xu',
        cancel: 'Hủy',
        list: 'Danh sách các đơn đã hoàn xu',
        name: 'Tên khách hàng',
        phoneNumber: 'Số điện thoại',
        createdDate: 'Ngày tạo đơn',
        refundDate: 'Ngày hoàn xu',
        export_success: 'Xuất file thành công',
        export_failed: 'Xuất file thất bại',
        type: 'Loại',
      },
      export: 'Xuất file',
    },
    edit: {
      editTitle: 'Chỉnh sửa đơn quà',
      editManageOrder: 'Quản lý đơn quà',
      editVoucherList: 'Quản lý đơn quà E-Voucher',
      editPhysicalList: 'Quản lý đơn quà vật lý',
      edit: 'Chỉnh sửa đơn quà',
    },
  },
  request_export: 'Danh sách file export',
  introduceUser: {
    list: 'Người dùng giới thiệu app ',
    title: 'Danh sách người dùng giới thiệu app thành công ',
  },
  groupUser: {
    title: 'Quản lí nhóm người dùng',
    create: 'Tạo nhóm người dùng',
    edit: 'Sửa nhóm người dùng',
    detail: 'Thông tin nhóm người dùng',
    list: 'Danh sách nhóm người dùng',
    createSuccess: 'Tạo mới thành công',
    createFail: 'Tạo mới thất bại',
    editSuccess: 'Chỉnh sửa thành công',
    editFail: 'Chỉnh sửa thất bại',
    form: {
      groupName: 'Tên nhóm người dùng',
      desc: 'Mô tả',
      listUser: 'Các ID thành viên nhóm',
      status: 'Trạng thái',
      pickUser: 'Chọn người dùng',
      add: 'Thêm',
    },
    deleteSuccess: 'Xóa nhóm người dùng thành công !',
    deleteFail: 'Xóa nhóm người dùng thất bại !',
  },
  termPolicy: {
    root: 'Chính sách/điều khoản',
    common: {
      delete: {
        content: 'Bạn chắc chắn muốn xóa {{name}} không?',
        multiple_content:
          'Bạn chắc chắc muốn xóa {{length}} chính sách/điều khoản này không?',
        root: 'xóa',
        success: 'Xóa chính sách/điều khoản thành công',
        fail: 'Xóa chính sách/điều khoản thất bại',
        multiple_success: 'Xóa chính sách/điều khoản {{length}} thành công',
        multiple_fail: 'Xóa thất bại {{length}} chính sách/điều khoản',
      },
      form: {
        info: 'Thông tin chính sách/điều khoản',
        name: 'Tên',
        status: 'Trạng thái',
        type: 'Thể loại',
        createdAt: 'Ngày tạo',
        updatedAt: 'Ngày cập nhật',
        content: 'Nội dung',
        lang: 'Ngôn ngữ',
        icon: 'Icon',
      },
      create: {
        success: 'Tạo chính sách/điều khoản thành công',
        fail: 'Tạo chính sách/điều khoản thất bại',
        invalidIcon: 'Thiếu Icon',
      },
      view: {
        sucess: '',
        fail: 'Xem chính sách/điều khoản thất bại',
        return: 'Trở về xem chi tiết',
      },
      update: {},
      list: {
        return: 'Trở về danh sách',
      },
    },
    list: {
      root: 'Danh sách chính sách/điều khoản',
    },
    detail: {
      root: 'Xem chi tiết chính sách/điều khoản',
    },
    create: {
      root: 'Thêm mới chính sách/điều khoản',
    },
    update: {
      root: 'Cập nhập chính sách/điều khoản',
    },
  },
  fileList: {
    title: 'Danh sách file',
    importFileList: 'Danh sách file import',
    retryFailed: 'Nhập lại file thất bại !',
    retrySuccess: 'Nhập lại file thành công !',
  },
  historyScan: {
    title: 'Lịch sử quét mã',
    list: 'Danh sách lịch sử quét mã',
    listDuplicate: 'Danh sách mã trùng',
    export: {
      successExport: 'Xuất file Excel thành công',
      failedExport: 'Xuất file Excel thất bại',
      titleConfirmExport:
        'Bạn có muốn tới trang danh sách xuất file để tiến hành tải file?',
      subtitleConfirmExport: 'Hành động này không thể hoàn tác',
      closeConfirmExport: 'Hủy',
      agreeConfirmExport: 'Đồng ý',
      title: 'Xuất dữ liệu',
    },
  },
  ruleManage: {
    title: 'Quản lý rule',
    list: 'Danh sách các rule',
    edit: 'Chỉnh sửa',
    detail: 'Thông tin rule',
    desc: 'Mô tả',
    status: 'Trạng thái rule',
    save: 'Lưu',
    cancel: 'Hủy',
  },
  gameGifts: {
    title: 'Quản lý giải thưởng game',
    list: 'Danh sách giải thưởng',
    create: 'Tạo mới giải thưởng',
    edit: 'Chỉnh sửa giải thưởng',
    detail: 'Thông tin giải thưởng',
    modal: {
      text: 'Bạn có chắc muốn xóa những giải thưởng này này ?',
    },
    deleteSuccess: 'Xóa thành công !',
    deleteFailed: 'Xóa thất bại !',
    form: {
      quantity: 'Số lượng giải',
      ordinal: 'Thứ tự ưu tiên',
      ordinalWheel: 'Thứ tự vòng quay',
      name: 'Tên giải',
      winRate: 'Tỉ lệ trúng giải',
      wonQuantity: 'Số lượng thắng giải',
      game: 'Game',
      productVariant: 'Biến thể sản phẩm',
      typeContraints: 'Loại giới hạn',
    },
  },
  configPlayTime: {
    root: 'Cấu hình lượt chơi',
    list: {
      title: 'Danh sách cấu hình',
      header: {
        productGroup: 'Nhóm sản phẩm',
        weight: 'Cân nặng',
        value: 'Lượt chơi',
      },
      action: {
        delete: {
          success: 'Xóa cấu hình thành công',
          failed: 'Xóa cấu hình thất bại',
          multiple_success: 'Xóa {{length}} config thành công',
          multiple_failed: 'Xóa {{length}} config thất bại',
        },
      },
    },
    create: {
      title: 'Thêm cấu hình',
      schema: {
        field_required: 'Trường này không được để trống',
        value_min: 'Số lượt chơi phải lớn hơn hoặc bằng 0.5',
      },
      form: {
        productGroup: 'Nhóm sản phẩm',
        weight: 'Trọng lượng',
        value: 'Số lượt chơi',
        create_success: 'Tạo cấu hình thành công',
        create_fail: 'Tạo cấu hình thất bại',
        edit_success: 'Sửa cấu hình thành công',
        edit_fail: 'Sửa cấu hình thất bại',
      },
    },
  },
  news: {
    list: {
      delete: 'Xóa',
      edit: 'Sửa',
      title: 'Danh sách tin tức',
      newNews: 'Thêm mới tin tức',
      labelTitle: 'Tiêu đề',
      labelSubject: 'Chủ đề',
      clear: 'Hủy',
      search: 'Tìm kiếm',
      deleteSuccess: 'Xóa tin tức thành công',
      deleteFail: 'Xóa tin tức thất bại',
      deletePopup: 'Xóa tin tức',
      confirmDelete: 'Bạn có chắc chắn muốn xóa tin tức này?',
      cancel: 'thoát',
      dense: 'Thu gọn',
      titleNewsNavbar: 'tin tức',
      listTitleNavbar: 'Danh sách tin tức',
    },
    new: {
      title: 'Thêm mới tin tức',
      labelTitle: 'Tiêu đề',
      labelSubject: 'Chủ đề',
      labelStatus: 'Trạng thái',
      labelImage: 'Ảnh tin tức',
      labelContent: 'Nội dung tin tức',
      newSuccess: 'Thêm mới tin tức thành công',
      newFail: 'Thêm mới tin tức thất bại',
      addBtn: 'Thêm mới',
      cancelBtn: 'Hủy',
      allow: 'Cho phép',
      maxSize: 'Dung lượng lớn nhất',
      schemaTitle: 'Vui lòng không để trống tiêu đề',
      schemaSubjectMin: 'Vui lòng thêm ít nhất 1 chủ đề cho tin tức',
      schemaSubject: 'Vui lòng không để trống chủ đề',
      schemaImage: 'Vui lòng không để trống ảnh tin tức',
      schemaContent: 'Vui lòng không để trống nội dung',
      author: 'Tác giả',
      description: 'Mô tả ngắn',
    },
    detail: {
      title: 'Chi tiết tin tức',
      editBtn: 'Sửa tin tức',
      labelAuthor: 'Tác giả',
      labelSubject: 'Chủ đề',
      labelContent: 'Nội dung',
      labelDescription: 'Mô tả',
      labelLang: 'Ngôn ngữ',
      labelStatus: 'Trạng thái',
    },
    edit: {
      author: 'Tác giả',
      description: 'Mô tả ngắn',
      title: 'Chỉnh sửa tin tức',
      labelTitle: 'Tiêu đề',
      labelSubject: 'Chủ đề',
      labelStatus: 'Trạng thái',
      labelImage: 'Ảnh tin tức',
      labelContent: 'Nội dung tin tức',
      newSuccess: 'Chỉnh sửa tin tức thành công',
      newFail: 'Chỉnh sửa tin tức thất bại',
      editBtn: 'Chỉnh sửa',
      cancelBtn: 'Hủy',
      allow: 'Cho phép',
      maxSize: 'Dung lượng lớn nhất',
      schemaTitle: 'Vui lòng không để trống tiêu đề',
      schemaSubjectMin: 'Vui lòng thêm ít nhất 1 chủ đề cho tin tức',
      schemaSubject: 'Vui lòng không để trống chủ đề',
      schemaImage: 'Vui lòng không để trống ảnh tin tức',
      schemaContent: 'Vui lòng không để trống nội dung',
    },
  },
  news_subject: {
    list: {
      delete: 'Xóa',
      edit: 'Sửa',
      title: 'Danh sách chủ đề',
      subjectNews: 'Thêm mới chủ đề',
      clear: 'Xóa hết',
      search: 'Tìm kiếm',
      deleteSuccess: 'Xóa chủ thành công',
      deleteFail: 'Xóa chủ đề thất bại',
      deletePopup: 'Xóa chủ đề',
      confirmDelete: 'Bạn có chắc chắn muốn xóa chủ đề này?',
      cancel: 'thoát',
      dense: 'Hiển thị dày hơn',
      titleNavbar: 'Chủ đề',
      listTitleNavbar: 'Danh sách chủ đề',
    },
    new: {
      title: 'Thêm mới chủ đề',
      labelName: 'Tên chủ đề',
      lang: 'Ngôn ngữ',
      newSuccess: 'Thêm mới chủ đề thành công',
      newFail: 'Thêm mới chủ đề thất bại',
      addBtn: 'Thêm mới',
      cancelBtn: 'Hủy',
    },
    edit: {
      title: 'Chỉnh sửa chủ đề',
      labelName: 'Tên chủ đề',
      lang: 'Ngôn ngữ',
      editSuccess: 'Chỉnh sửa chủ đề thành công',
      editFail: 'Chỉnh sửa chủ đề thất bại',
      addBtn: 'Chỉnh sửa',
      cancelBtn: 'Hủy',
    },
  },
  configApp: {
    title: 'Cấu hình App',
    version: 'Phiên bản',
    os: 'Hệ điều hành',
    list: 'Danh sách cấu hình app',
    modal: {
      title: 'Chỉnh sửa cấu hình',
    },
  },
  analystPoint: {
    title: 'Thống kê số xu',
    startDate: 'Từ ngày',
    endDate: 'Đến ngày',
    chart: {
      title: 'Biểu đồ',
      circle: 'Biểu đồ tròn',
      line: 'Biểu đồ đường',
    },
  },
  statistic: 'Thống kê',
  analystSpoonUsed: {
    title: 'Mã muỗng đã tích',
    startDate: 'Từ ngày',
    endDate: 'Đến ngày',
    chart: {
      title: 'Biểu đồ',
      circle: 'Biểu đồ tròn',
      line: 'Biểu đồ đường',
      used: 'Đã sử dụng',
      unused: 'Chưa sử dụng',
    },
    export: {
      successExport: 'Xuất file Excel thành công',
      failedExport: 'Xuất file Excel thất bại',
      titleConfirmExport:
        'Bạn có muốn tới trang danh sách xuất file để tiến hành tải file?',
      subtitleConfirmExport: 'Hành động này không thể hoàn tác',
      closeConfirmExport: 'Hủy',
      agreeConfirmExport: 'Đồng ý',
    },
  },
  analystSpoonUnused: {
    title: 'Mã muỗng đã xuất',
    startDate: 'Từ ngày',
    endDate: 'Đến ngày',
    chart: {
      title: 'Biểu đồ',
      circle: 'Biểu đồ tròn',
      line: 'Biểu đồ đường',
      used: 'Đã sử dụng',
      unused: 'Chưa sử dụng',
    },
    export: {
      successExport: 'Xuất file Excel thành công',
      failedExport: 'Xuất file Excel thất bại',
      titleConfirmExport:
        'Bạn có muốn tới trang danh sách xuất file để tiến hành tải file?',
      subtitleConfirmExport: 'Hành động này không thể hoàn tác',
      closeConfirmExport: 'Hủy',
      agreeConfirmExport: 'Đồng ý',
    },
  },
  analystScan: {
    title: 'Thống kê tích xu',
    startDate: 'Từ ngày',
    endDate: 'Đến ngày',
    chart: {
      title: 'Biểu đồ',
      circle: 'Biểu đồ tròn',
      line: 'Biểu đồ đường',
    },
    export: {
      successExport: 'Xuất file Excel thành công',
      failedExport: 'Xuất file Excel thất bại',
      titleConfirmExport:
        'Bạn có muốn tới trang danh sách xuất file để tiến hành tải file?',
      subtitleConfirmExport: 'Hành động này không thể hoàn tác',
      closeConfirmExport: 'Hủy',
      agreeConfirmExport: 'Đồng ý',
    },
  },
  configShareApp: {
    root: 'Cấu hình chia sẻ app',
    add_section: 'Thêm banner',
    edit: 'Chỉnh sửa',
    save: 'Lưu',
  },
};

export default vn;
